// Cached wallet_getCapabilities helper (EIP-5792)
// Keeps a 5-minute TTL to avoid spamming the provider.

const CACHE_TTL = 5 * 60 * 1000; // 5 min
let _cache = null;
let _ts = 0;

export async function getWalletCaps(provider = null) {
  if (!provider && typeof window !== 'undefined') provider = window.ethereum;
  if (!provider?.request) return {};

  const now = Date.now();
  if (_cache && (now - _ts) < CACHE_TTL) return _cache;

  try {
    const caps = await provider.request({ method: 'wallet_getCapabilities' });
    if (caps && typeof caps === 'object') {
      _cache = caps;
      _ts = now;
      return caps;
    }
  } catch {/* ignore */}
  return {};
}

export function hasSponsoredCalls() {
  return !!_cache?.sponsoredCalls;
} 